import { Button, DatePicker, Form, Select } from "antd";
import moment from "moment";
import { ArrayOption, selectSearchOption } from "../../../helpers/siteConfig";
import { towerTicketStartAsync } from "../../../store/features/NP/network/networkAPI";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import CustomModal from "../../common/CustomModal";
import { phaseList } from "./TicketGenerate";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

type Props = {
  open: boolean;
  handleClose: (val?: boolean) => void;
  data?: any;
};

export default function PGEnableModal({ open, handleClose, data }: Props) {
  const dispatch = useAppDispatch();
  const { postLoading } = useAppSelector((state) => state.network);

  const onFinish = (values: any) => {
    const { dcOccuredTime, mFOccuredTime, ...rest } = values;

    const newValues = {
      dcOccuredTime: dcOccuredTime.utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
      mFOccuredTime: mFOccuredTime.utc().format("YYYY-MM-DDTHH:mm:ss[Z]"),
      ...rest,
    };

    dispatch(
      towerTicketStartAsync({
        data: newValues,
        others: {
          id: data,
          reRender: handleClose,
        },
      })
    );
  };

  return (
    <CustomModal
      width={600}
      title="PG Enable"
      open={open}
      handleClose={() => handleClose()}
    >
      <div className="p-6">
        <Form
          className="custom-form hide_star_mark highlight_placeholder"
          layout="vertical"
          onFinish={onFinish}
          size="large"
        >
          <Form.Item
            label="Mains Fail"
            name="mFOccuredTime"
            className="mb-4"
            rules={[
              {
                required: false,
                message: "Please enter mains fail",
              },
            ]}
          >
            <DatePicker
              showTime={{ format: "hh:mm A" }}
              format="YYYY-MM-DD hh:mm A"
              size="large"
              className="w-full"
              disabledDate={(current) =>
                // current.isBefore(moment().subtract(1, "day") as any)
                current &&
                current.format("YYYY-MM-DD") !== moment().format("YYYY-MM-DD")
              }
            />
          </Form.Item>
          <Form.Item
            name="mFStatus"
            label="Select DC Low"
            className="mb-4"
            rules={[
              {
                required: false,
                message: "Please select DC Low",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={[
                { label: "True", value: true },
                { label: "False", value: false },
              ]}
            />
          </Form.Item>
          <Form.Item
            name="dcOccuredTime"
            label="Site Down"
            className="mb-4"
            rules={[
              {
                required: false,
                message: "Please enter Site Down",
              },
            ]}
          >
            <DatePicker
              showTime={{ format: "hh:mm A" }}
              format="YYYY-MM-DD hh:mm A"
              size="large"
              className="w-full"
              disabledDate={(current) =>
                current &&
                current.format("YYYY-MM-DD") !== moment().format("YYYY-MM-DD")
              }
            />
          </Form.Item>
          <Form.Item
            name="dcStatus"
            label="Select Down"
            className="mb-4"
            rules={[
              {
                required: false,
                message: "Please select down",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={[
                { label: "True", value: true },
                { label: "False", value: false },
              ]}
            />
          </Form.Item>

          <Form.Item
            label="Select operator"
            name="operator"
            className="mb-4"
            rules={[
              {
                required: false,
                message: "Please select operator",
              },
            ]}
          >
            <Select
              placeholder="Select"
              size="large"
              allowClear
              showSearch
              filterOption={selectSearchOption}
              options={ArrayOption(phaseListPgEnable, "name", "value")}
            />
          </Form.Item>

          <Button
            className="mt-2"
            type="primary"
            size="large"
            htmlType="submit"
            block
            loading={postLoading}
          >
            Submit
          </Button>
        </Form>
      </div>
    </CustomModal>
  );
}

export const phaseListPgEnable = [
  {
    name: "Robi",
    value: "robi",
  },
  // {
  //   name: "Airtel",
  //   value: "rirtel",
  // },
  {
    name: "Grameenphone",
    value: "gp",
  },
  // {
  //   name: "Both",
  //   value: "both",
  // },

  // {
  //   name: "Banglalink",
  //   value: "banglalink",
  // },
  // {
  //   name: "Teletalk",
  //   value: "teletalk",
  // },
];
